import React, { FC } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MuiTelInput } from "mui-tel-input";

import { CompanyEditorFieldProps } from "../../CompanyEditor.types";

import { TextField, Typography } from "@components/base";

const OwnerDetails: FC<CompanyEditorFieldProps> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="subtitle2" sx={{ mt: 2 }}>
        {t("admin.ownerDetails")}
      </Typography>

      <Typography variant="body2" color="text.secondary">
        {t("common.email")}
        {" *"}
      </Typography>
      <Controller
        name="ownerEmail"
        control={control}
        rules={{
          required: true,
          pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            variant="filled"
            fullWidth
            placeholder={t("common.email")}
            error={!!error}
            {...field}
          />
        )}
      />

      <Typography variant="body2" color="text.secondary">
        {t("common.firstName")}
        {" *"}
      </Typography>
      <Controller
        name="ownerFirstName"
        control={control}
        rules={{ required: true }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            variant="filled"
            fullWidth
            placeholder={t("common.firstName")}
            error={!!error}
            {...field}
          />
        )}
      />

      <Typography variant="body2" color="text.secondary">
        {t("common.lastName")}
        {" *"}
      </Typography>
      <Controller
        name="ownerLastName"
        control={control}
        rules={{ required: true }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            variant="filled"
            fullWidth
            placeholder={t("common.lastName")}
            error={!!error}
            {...field}
          />
        )}
      />

      <Typography variant="body2" color="text.secondary">
        {t("common.password")}
        {" *"}
      </Typography>
      <Controller
        name="ownerPassword"
        control={control}
        rules={{
          required: true,
          minLength: 8,
          pattern:
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9\s]).+$/,
        }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            type="password"
            variant="filled"
            fullWidth
            placeholder={t("common.password")}
            error={!!error}
            helperText={
              error ? t("validation.passwordRequirements") : undefined
            }
            {...field}
          />
        )}
      />

      <Typography variant="body2" color="text.secondary">
        {t("common.phoneNumber")}
      </Typography>
      <Controller
        name="ownerPhoneNumber"
        control={control}
        render={({ field }) => (
          <MuiTelInput
            {...field}
            value={field.value ?? ""}
            defaultCountry="CZ"
            variant="filled"
            fullWidth
            placeholder={t("common.phoneNumber")}
          />
        )}
      />
    </>
  );
};

export default OwnerDetails;
